import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, ViewWillEnter } from '@ionic/angular';
import { modalEnterAnimation, modalLeaveAnimation } from 'src/app/animation/modal.animation';
import { NotificationModel } from 'src/app/models/notification.model';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { NotificationDetailComponent } from '../notification-detail/notification-detail.component';
import { Title } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy, ViewWillEnter {

  notifications: NotificationModel[] = [];

  constructor(
    public notificationServ: NotificationsService,
    public dataServ: DataService,
    private modalServ: ModalMakerService,
    private mdlCtrl: ModalController,
    private titleService: Title,
    public authServ: AuthService
  ) { }

  async ngOnInit() {
    this.notifications = await this.notificationServ.getNotifications(this.dataServ.rData.id); 
  }

  ionViewWillEnter(): void {
    this.titleService.setTitle('Notifications');
  }

  ngOnDestroy(): void {
    this.titleService.setTitle('My Profile');
  }

  async close() {
    await this.mdlCtrl.dismiss();
  }

  async openNotification(notificationData: NotificationModel) {

    const NOTI: number[] = JSON.parse(localStorage.getItem('readedNoti')) || [];

    NOTI.push(notificationData.id);

    localStorage.setItem('readedNoti', JSON.stringify(NOTI));

    if (notificationData.type === 'survey') {
      this.modalServ.survey(notificationData, 'notification');
      return null;
    }

    this.modalServ.openNotification(notificationData);
  }
}
